import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PAGE_ROUTES from '../utils/constant';
import MainConatiner from './MainConatiner';
import { getCurrentAuth } from '../hooks/http-server';

interface PrivateRouteProps {
  children: ReactNode;
}

const PublicRoute: FC<PrivateRouteProps> = ({ children, ...rest }) => {
  const [role, setRole] = useState<string>('tagger');

  const auth = getCurrentAuth();

  if (!auth) {
    return children as JSX.Element;
  } else {
    return <Navigate to={PAGE_ROUTES.GAMES} />;
  }
};

export default PublicRoute;
